module.exports = __webpack_public_path__ + "img/swipe.6fe2a227.png";